module.exports = __webpack_public_path__ + "img/ELMY.17fe5e0a.png";